import cloneDeep from 'lodash/cloneDeep';

import type { BundleFinishType, BundleType, PageModel } from '@webapp/common/resources/entities';

import type { QuestionActorRef } from '@webapp/survey/src/machine/question-machine';

import { getQ } from '../machine/lib';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
// export interface BundleEntity extends BundleModel {}

class BundleModel {
    type: BundleType;
    finishType: BundleFinishType;
    random: boolean;
    text: string;
    questions: Array<QuestionActorRef>;
    page: PageModel;
    redirect: string | number | null;
    copyUrlParams?: boolean;
}

export const initialSurveyBundle: Readonly<BundleModel> = {
    type: null,
    finishType: null,
    random: false,
    text: null,
    page: null,
    questions: [],
    redirect: null,
};

export class BundleEntity extends BundleModel {
    public questions: Array<QuestionActorRef> = [];

    public get isValid(): boolean {
        return this.questions.every((questionRef) => {
            const q = getQ(questionRef);
            return !q.invalid && !q.commentInvalid;
        });
    }

    public get withTestAnswerReacting(): boolean {
        return this.questions.some((questionRef) => {
            const q = getQ(questionRef);

            return q.params.testAnswerReaction === true && !q.testAnswerReactingState;
        });
    }

    public stopTimers() {
        this.questions.forEach((q) => {
            q.send({ type: 'STOP_TIMER' });
        });
    }

    public validate() {
        this.questions.forEach((q) => {
            return q.send({ type: 'VALIDATE' });
        });
    }

    constructor(init: Partial<BundleModel>, questions: Array<QuestionActorRef>) {
        super();

        for (const [k, v] of Object.entries({ ...cloneDeep(initialSurveyBundle), ...init })) {
            this[k] = v;
        }

        this.questions = questions || [];
    }
}
